import NavBar from '../components/navbar'
import Carousel from '../components/carousel'
import UpcomingEvents from '../components/upcoming_events'
import LaterEvents from '../components/later_events'
import Marketplace from '../components/marketplace_nav'
import Partners from '../components/partners'
import Event_Proposal from '../components/event_proposal'
import Footer from '../components/footer'
import { Helmet } from 'react-helmet';

export default function MainPage() {
    return (
      <>
        <Helmet>
          <title>Front-Row</title>
        </Helmet>
        <div>
          <head>
              <meta charset="UTF-8"/>
              <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
              <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
              <title>StaticICWebsite</title>
              <link rel="stylesheet" href="style.css"/>
          </head>
          <NavBar></NavBar>
          <Carousel></Carousel>
          <UpcomingEvents></UpcomingEvents>
          <LaterEvents></LaterEvents>
          <Marketplace></Marketplace>
          <Partners></Partners>
          <Event_Proposal></Event_Proposal>
          <Footer></Footer>
        </div>
      </>
    )
}